import axios from 'axios'

const RequestService = {
  async get (params = {}) {
    return axios.get('prd/purchase-order/requests', { params })
  },

  async histories (params = {}) {
    return axios.get('prd/reports/purchase-order/request-histories', { params })
  },

  async show (id) {
    return axios.get(`prd/purchase-order/requests/${id}`)
  },

  async post (params = {}) {
    return axios.post('prd/purchase-order/requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`prd/purchase-order/requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`prd/purchase-order/requests/${data.id}`, { data })
  }
}

export default RequestService
